import React, { useRef } from 'react';
import './Home.css';
import { useMovieContext } from '../context/MovieContext';
import Hero from './Hero';

function Home() {
    const { movies, latestMovies, trendingMovies, topRatedMovies, upcomingMovies, handleSelectMovie, error } = useMovieContext();
    const latestMovieRef = useRef(null);
    const trendingMovieRef = useRef(null);
    const topRatedMovieRef = useRef(null);
    const upcomingMovieRef = useRef(null);

    if (error) return <div>Error: {error}</div>;

    return (
        <React.Fragment>
            <div className='bg'>
                <Hero />
                <div className='section'>
                    <h2 className="section-heading">Latest Movies</h2>
                    <div className="horizontal-scroll-container" ref={latestMovieRef}>
                        {latestMovies && latestMovies.map(movie => (
                            <div key={movie.id} className="movie-card" onClick={() => handleSelectMovie(movie.id)}>
                                <img className="movie-poster" src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`} alt={movie.title} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className='section'>
                    <h2 className="section-heading">Trending Movies</h2>
                    <div className="horizontal-scroll-container" ref={trendingMovieRef}>
                        {trendingMovies && trendingMovies.map(movie => (
                            <div key={movie.id} className="movie-card" onClick={() => handleSelectMovie(movie.id)}>
                                <img className="movie-poster" src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`} alt={movie.title} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className='section'>
                    <h2 className="section-heading">Top Rated Movies</h2>
                    <div className="horizontal-scroll-container" ref={topRatedMovieRef}>
                        {topRatedMovies && topRatedMovies.map(movie => (
                            <div key={movie.id} className="movie-card" onClick={() => handleSelectMovie(movie.id)}>
                                <img className="movie-poster" src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`} alt={movie.title} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className='section'>
                    <h2 className="section-heading">Upcoming Movies</h2>
                    <div className="horizontal-scroll-container" ref={upcomingMovieRef}>
                        {upcomingMovies && upcomingMovies.map(movie => (
                            <div key={movie.id} className="movie-card" onClick={() => handleSelectMovie(movie.id)}>
                                <img className="movie-poster" src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`} alt={movie.title} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="movie-list-container">
                    <h2 className="movie-list-heading">Now Playing</h2>
                    <div className="movie-grid">
                        {movies && movies.map(movie => (
                            <div key={movie.id} className="movie-card" onClick={() => handleSelectMovie(movie.id)}>
                                <img className="movie-poster" src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`} alt={movie.title} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Home;
